// Map-first home on phones — switched OFF at the user's request; flip to true to bring it back.
export const MAP_HOME_ON_MOBILE = false;
export const CLASSIC_HOME_KEY = "lp-home-classic";
